import React, { ChangeEvent } from 'react';
import { OpenComponent } from '../../enums/misc.enum';
import { Roles } from '../../enums/roles-enum';
import { truncateString } from '../../helpers/common.helpers';
import useAuth from '../../hooks/useAuth';
import { BasicReseller } from '../../type/entity.types';
import StatusText from '../admin-table/components/status-text.component';
import XSafeTextInfo from '../x-components/x-safe-text-info.component';
import XSkeletonLoadingTableBody from '../x-components/x-skeletons/x-skeleton-loading-table.component';
import XThead from '../x-components/x-table-header.component';
import XTable from '../x-components/x-table/x-table.component';

interface Props {
  resellersData?: BasicReseller[];
  setSelectedEntity: React.Dispatch<React.SetStateAction<number | undefined>>;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  isChecked: number[];
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  checkedAll: boolean;
  setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
}

function ResellersTable(props: Props) {
  const {
    resellersData,
    setSelectedEntity,
    setComponentManager,
    isChecked,
    setIsChecked,
    checkedAll,
    setCheckedAll,
    isLoading,
  } = props;
  const { auth } = useAuth();
  const isViewOnly =
    auth?.role === Roles.SETTLEMENT || auth?.role === Roles.CHECKER;

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    if (checked) {
      setIsChecked([...isChecked, Number(id)]);
    } else {
      setIsChecked(isChecked.filter((item) => item !== Number(id)));
    }
  };

  const handleCheckAll = () => {
    if (!resellersData) {
      return;
    }
    let arr = resellersData;
    setCheckedAll(!checkedAll);

    if (checkedAll) {
      setIsChecked([]);
    } else {
      setIsChecked(arr.map((li) => li.resellerId));
    }
  };

  return (
    <>
      <XTable>
        <XThead>
          <tr>
            {!isViewOnly && (
              <th style={{ width: 30 }}>
                <input
                  type='checkbox'
                  style={{ cursor: 'pointer' }}
                  onChange={handleCheckAll}
                  checked={checkedAll}
                />
              </th>
            )}
            <th>Reseller name</th>
            <th>Primary contact number</th>
            <th>Location</th>
            <th>Associated partner</th>
            <th>Status</th>
          </tr>
        </XThead>
        {isLoading ? (
          <XSkeletonLoadingTableBody numColumns={6} />
        ) : (
          <tbody>
            {resellersData?.map((reseller) => (
              <tr key={reseller.resellerId}>
                {!isViewOnly && (
                  <td>
                    <input
                      type='checkbox'
                      style={{ cursor: 'pointer' }}
                      name=''
                      id={reseller.resellerId.toString()}
                      checked={isChecked.includes(reseller.resellerId)}
                      onChange={handleCheck}
                    />
                  </td>
                )}

                <td
                  onClick={() => {
                    setSelectedEntity(reseller.resellerId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo
                    data={truncateString(reseller.resellerName, 20)}
                  />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(reseller.resellerId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={reseller.contact.phone.primary} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(reseller.resellerId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={reseller.address.city} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(reseller.resellerId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={reseller.associatedPartner} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(reseller.resellerId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <StatusText
                    status={reseller.isActive ? 'ENABLED' : 'DISABLED'}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </XTable>
    </>
  );
}

export default ResellersTable;
